import React, { FunctionComponent, useContext } from "react";
import { ArrowIcon } from "@cmsgov/ds-medicare-gov";
import { SearchResultPlan, UserLanguage } from "../../../../@types";
import {
  getPlanName,
  makePlanDetailsUrl,
  makePlanDisplayId,
  useTranslate,
} from "../../../../helpers";
import BasePlanCard from "./BasePlanCard";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { CurrentCoverageCardProps } from "./CurrentCoverageCard";
import { AppContext } from "../../../../app/store";
import { AnalyticsActionType } from "../../../../app/contexts/Analytics/types";

interface RolloverPlanCardProps extends CurrentCoverageCardProps {
  plan: SearchResultPlan;
}

export const rolloverCoverageCardTestId = "rollover-coverage-card";

const RolloverCoverageCard: FunctionComponent<RolloverPlanCardProps> = ({
  plan,
  language = UserLanguage.ENGLISH,
}) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  const url = window.location.href.split("/summary?")[0];
  const planDetailsLink = makePlanDetailsUrl({
    plan,
    language,
    yearValue: "contract_year",
  });
  const linkText = t("summary_page.links.get_plan_details");
  return (
    <BasePlanCard
      dataTestId={rolloverCoverageCardTestId}
      additionalClassNames="e2e-rollover-coverage-card"
      header={
        plan?.contract_year && (
          <FormattedMessage
            id="summary_page.plan_cards.rollover_coverage.header"
            values={{ year: plan.contract_year }}
          />
        )
      }
      subHeader={t("summary_page.plan_cards.rollover_coverage.subheader")}
      planHeader={
        <p className="mct-c-summary-page-plan-card__plan-header">
          {plan && getPlanName(plan, language)}
        </p>
      }
      planId={plan && makePlanDisplayId(plan)}
      footer={
        <>
          <Link
            className="mct-c-summary-page-plan-card__link"
            to={planDetailsLink}
            onClick={() =>
              dispatch({
                type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
                settings: {
                  linkText,
                  linkUrl: `${url}${planDetailsLink}`,
                },
              })
            }
          >
            {linkText}
          </Link>
          <ArrowIcon className="ds-u-margin-left--05" direction="right" />
        </>
      }
    />
  );
};

export default RolloverCoverageCard;
